import React, {useEffect, createRef} from 'react';
import { 
        SurveyRadioButtonsContainer, 
        SurveyRadioButtonsLabel, 
        SurveyRadioButtonsShowOptionSelectedMessageError
      } from './styles';

const SurveyRadioButtons = ({id, minValue, maxValue, clickFunction}) => {
  return (
    <SurveyRadioButtonsContainer id={'survey-radio-' + id}>
      {
        [...Array((maxValue-minValue+1))].map((_, i) => (
          <>
             <input type="radio" name={"points"} key={i} id={(i + minValue).toString()} onClick={() => clickFunction(i + minValue)} />
             <SurveyRadioButtonsLabel htmlFor={(i + minValue).toString()}>{(i + minValue).toString()}</SurveyRadioButtonsLabel>
          </>
        ))
      }
    </SurveyRadioButtonsContainer>
  )
}

export default SurveyRadioButtons
